import React, { Component } from 'react';
import Structure from '../../inc/structure';
import FeatherIcon from 'feather-icons-react';
import { Switch } from '@material-ui/core';
import { Nav, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import Modal from '../modals/Modal';
import AddSavings from '../modals/AddSavings';
import GetApi from '../../api_request/Get';
import { ServerLink } from '../../keys/Links';
import notifyError from '../../inc/SnackbarError';
import NumberFormat from 'react-number-format';
import FontAwesome from 'react-fontawesome';
import EditSavings from '../modals/EditSavings';
import AddMoney from '../modals/AddMoney';
import AddMoneyPurse from '../modals/AddMoneyPurse';


class Purse extends Component {



    constructor(props) {
        super(props)

        this.state = {
            title: 'Loading ....',
            campaign: false,
            modalx: true,
            modalToggle: false,
            modalSavings: false,
            modalSaveMoney: false,
            savings: '',
            isLoading: true,
            purseTarget: 0,
            totalSavings: 0,
            history: [],
            withdrawalHistory: [],
            query: 'all',
            selectedTransaction: null,
            showTransactionModal: false,
            selectedWithdrawal: null,
            showWithdrawalModal: false,
            activeHistoryTab: 'savings',
            countdownTrigger: 0,
        }




        this.getSaving()
    }



    componentDidMount() {
        // Set up countdown timer to update every second
        this.countdownInterval = setInterval(() => {
            this.setState(prevState => ({
                countdownTrigger: prevState.countdownTrigger + 1
            }))
        }, 1000)
    }

    componentWillUnmount() {
        // Clean up interval on unmount
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval)
        }
    }


    getSaving = (e) => {

        //e.preventDefault()


        const { match: { params } } = this.props;

        //get the Card
        GetApi(ServerLink + '/user/purse/' + params.id).then(
            res => {

                console.log(res)

                if (res.status == true) {

                    this.setState({
                        savings: res.data,
                        history: res.history,
                        withdrawalHistory: res.withdrawal_history,
                        isLoading: false
                    })
                }
                else {

                    notifyError(res.message, 'error', 'top-center')
                    this.setState({
                        isLoading: false
                    })
                }
            }
        ).catch(e => {
            console.log(e)

            //notifyError('Oops.. Something went wrong, check your internet connection', 'error','top-center')
            notifyError(e, 'error', 'top-center')
            this.setState({
                isLoading: false
            })
        })
    }



    modalHandler = (e) => {
        e.preventDefault();



        this.setState(
            {
                modalToggle: !this.state.modalToggle,

            }
        )
    }

    modalAddSavings = (e) => {
        e.preventDefault();

        this.setState(
            {
                modalSavings: !this.state.modalSavings,
            }
        )
    }

    modalAddMoney = (e) => {

        e.preventDefault();

        this.setState({
            modalSaveMoney: !this.state.modalSaveMoney
        })
    }

    openTransactionModal = (transaction) => {
        this.setState({
            selectedTransaction: transaction,
            showTransactionModal: true
        })
    }

    closeTransactionModal = () => {
        this.setState({
            selectedTransaction: null,
            showTransactionModal: false
        })
    }

    openWithdrawalModal = (withdrawal) => {
        this.setState({
            selectedWithdrawal: withdrawal,
            showWithdrawalModal: true
        })
    }

    closeWithdrawalModal = () => {
        this.setState({
            selectedWithdrawal: null,
            showWithdrawalModal: false
        })
    }

    getStatusInfo = (status) => {
        const statusMap = {
            0: { label: 'Pending', icon: 'clock', color: 'yellow', bgColor: 'bg-yellow-100', textColor: 'text-yellow-700', badge: 'bg-yellow-200' },
            1: { label: 'Approved', icon: 'check-circle', color: 'green', bgColor: 'bg-green-100', textColor: 'text-green-700', badge: 'bg-green-200' },
            2: { label: 'Rejected', icon: 'x-circle', color: 'red', bgColor: 'bg-red-100', textColor: 'text-red-700', badge: 'bg-red-200' }
        }
        return statusMap[status] || statusMap[0]
    }

    getPaymentMethodInfo = (transaction) => {
        const method = transaction.payment_method || transaction.payment_type || 'unknown'
        const methodMap = {
            'card': { label: 'Card Payment', icon: 'credit-card', color: 'purple' },
            'bank_transfer': { label: 'Bank Transfer', icon: 'send', color: 'blue' },
            'virtual_account': { label: 'Virtual Account', icon: 'inbox', color: 'indigo' },
            'ussd': { label: 'USSD', icon: 'phone', color: 'orange' }
        }
        return methodMap[method] || { label: method.replace('_', ' '), icon: 'arrow-right', color: 'gray' }
    }

    calculateProgress = () => {
        const { savings } = this.state
        if (!savings.target || savings.target === '0') return 0
        const progress = (savings.balance / savings.target) * 100
        return Math.min(progress, 100)
    }

    getTotalWithdrawn = () => {
        if (!this.state.withdrawalHistory || this.state.withdrawalHistory.length === 0) return 0
        return this.state.withdrawalHistory.reduce((total, withdrawal) => {
            return total + (parseFloat(withdrawal.amount) || 0)
        }, 0)
    }

    /**
     * Calculate time remaining until end date
     * Returns formatted string like "5d 2h 30m" or "Expired"
     */
    getTimeRemaining = (endDate) => {
        if (!endDate) return 'No deadline';
        
        const now = new Date();
        const end = new Date(endDate);
        const diff = end - now;
        
        if (diff <= 0) {
            return 'Expired';
        }
        
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        
        if (days > 0) {
            return `${days}d ${hours}h ${minutes}m`;
        } else if (hours > 0) {
            return `${hours}h ${minutes}m`;
        } else {
            return `${minutes}m`;
        }
    }




    ModalContent = () => {

        if (this.state.showWithdrawalModal && this.state.selectedWithdrawal) {
            const withdrawal = this.state.selectedWithdrawal
            const statusInfo = this.getStatusInfo(withdrawal.status)

            return (
                <Modal show={this.state.showWithdrawalModal} modalClosed={this.closeWithdrawalModal}>
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold workSanBold">Withdrawal Details</h2>
                            <a onClick={this.closeWithdrawalModal} className="cursor-pointer text-gray-500 hover:text-red-600">
                                <FeatherIcon icon="x" size="28" />
                            </a>
                        </div>

                        {/* Amount and Status */}
                        <div className="bg-gradient-to-r from-red-50 to-pink-50 rounded-xl p-6 mb-6 border border-red-200">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-gray-600 text-sm workSan">Withdrawal Amount</p>
                                    <h3 className="text-3xl font-bold text-red-700 workSanBold">
                                        <NumberFormat value={withdrawal.amount} displayType='text' thousandSeparator={true} prefix="₦" />
                                    </h3>
                                </div>
                                <div className={`px-4 py-2 rounded-full flex items-center gap-2 ${statusInfo.badge}`}>
                                    <FeatherIcon icon={statusInfo.icon} size="18" className={statusInfo.textColor} />
                                    <span className={`font-semibold ${statusInfo.textColor}`}>{statusInfo.label}</span>
                                </div>
                            </div>
                        </div>

                        {/* Details Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            {/* Purse Name */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Savings Purse</p>
                                <p className="font-semibold text-gray-800">{withdrawal.purse_name}</p>
                            </div>

                            {/* Reference */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Reference</p>
                                <p className="font-mono font-bold text-gray-800">{withdrawal.reference}</p>
                            </div>

                            {/* Bank Details */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Bank</p>
                                <p className="font-semibold text-gray-800">{withdrawal.bank}</p>
                            </div>

                            {/* Account Number */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Account Number</p>
                                <p className="font-mono font-bold text-gray-800">{withdrawal.account_number}</p>
                            </div>

                            {/* Date */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Withdrawal Date</p>
                                <p className="font-semibold text-gray-800">{withdrawal.date}</p>
                            </div>

                            {/* Full Name */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Full Name</p>
                                <p className="font-semibold text-gray-800">{withdrawal.fullname || 'N/A'}</p>
                            </div>
                        </div>

                        {/* Reason if available */}
                        {withdrawal.reason && (
                            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                                <div className="flex items-start gap-3">
                                    <FeatherIcon icon="info" size="20" className="text-blue-600 mt-1" />
                                    <div className="flex-1">
                                        <p className="text-sm text-blue-900 font-semibold">Withdrawal Reason</p>
                                        <p className="text-sm text-blue-800">{withdrawal.reason}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Close Button */}
                        <button 
                            onClick={this.closeWithdrawalModal}
                            className="w-full py-3 bg-gradient-to-r from-red-600 to-pink-600 text-white font-bold rounded-lg hover:shadow-lg transition-all duration-300"
                        >
                            Close
                        </button>
                    </div>
                </Modal>
            )
        }

        if (this.state.showTransactionModal && this.state.selectedTransaction) {
            const trans = this.state.selectedTransaction
            const statusInfo = this.getStatusInfo(trans.status)
            const paymentInfo = this.getPaymentMethodInfo(trans)

            return (
                <Modal show={this.state.showTransactionModal} modalClosed={this.closeTransactionModal}>
                    <div className="p-6">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold workSanBold">Transaction Details</h2>
                            <a onClick={this.closeTransactionModal} className="cursor-pointer text-gray-500 hover:text-red-600">
                                <FeatherIcon icon="x" size="28" />
                            </a>
                        </div>

                        {/* Amount and Status */}
                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 mb-6 border border-blue-200">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-gray-600 text-sm workSan">Transaction Amount</p>
                                    <h3 className="text-3xl font-bold text-blue-700 workSanBold">
                                        <NumberFormat value={trans.amount} displayType='text' thousandSeparator={true} prefix="₦" />
                                    </h3>
                                </div>
                                <div className={`px-4 py-2 rounded-full flex items-center gap-2 ${statusInfo.badge}`}>
                                    <FeatherIcon icon={statusInfo.icon} size="18" className={statusInfo.textColor} />
                                    <span className={`font-semibold ${statusInfo.textColor}`}>{statusInfo.label}</span>
                                </div>
                            </div>
                        </div>

                        {/* Details Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                            {/* Transaction ID */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Transaction ID</p>
                                <p className="font-mono font-bold text-gray-800">{trans.trans_id}</p>
                            </div>

                            {/* Payment Method */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div className="flex items-center gap-2">
                                    <FeatherIcon icon={paymentInfo.icon} size="20" className={`text-${paymentInfo.color}-600`} />
                                    <div>
                                        <p className="text-gray-500 text-sm workSan">Payment Method</p>
                                        <p className="font-semibold text-gray-800">{paymentInfo.label}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Date */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Transaction Date</p>
                                <p className="font-semibold text-gray-800">{trans.date || trans.payment_date}</p>
                            </div>

                          

                            {/* Full Name */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Full Name</p>
                                <p className="font-semibold text-gray-800">{trans.fullname || 'N/A'}</p>
                            </div>

                            {/* Title/Purpose */}
                            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <p className="text-gray-500 text-sm workSan mb-1">Savings Purpose</p>
                                <p className="font-semibold text-gray-800">{trans.title}</p>
                            </div>
                        </div>

                        {/* Receipt if available */}
                        {trans.receipt && (
                            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                                <div className="flex items-center gap-3">
                                    <FeatherIcon icon="file" size="20" className="text-amber-600" />
                                    <div className="flex-1">
                                        <p className="text-sm text-amber-900">Receipt Available</p>
                                        <p className="font-mono text-xs text-amber-700">{trans.receipt}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Close Button */}
                        <button 
                            onClick={this.closeTransactionModal}
                            className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-lg hover:shadow-lg transition-all duration-300"
                        >
                            Close
                        </button>
                    </div>
                </Modal>
            )
        }

        if (this.state.modalSavings) {

            return (

                <Modal show={this.state.modalSavings} modalClosed={this.modalAddSavings}>

                    <div>
                        <a onClick={this.modalAddSavings} className="float-right"><FeatherIcon icon="x-circle" /></a>
                    </div>

                    <EditSavings data={this.state.savings} />
                </Modal>
            );


        }

        if (this.state.modalSaveMoney) {


            return (

                <Modal show={this.state.modalSaveMoney} modalClosed={this.modalAddMoney}>

                    <div>
                        <a onClick={this.modalAddMoney} className="float-right text-red-700"><FeatherIcon icon="x-circle" className="text-red-700" /></a>
                    </div>

                    <AddMoney data={this.state.savings} />

                </Modal>
            )
        }


        if (this.state.modalToggle) {

            return (

                <Modal show={this.state.modalToggle} modalClosed={this.modalHandler}>
                    <div>
                        <a onClick={this.modalHandler} className="float-right"><FeatherIcon icon="x-circle" /></a>

                        <div className="pt-40 px-3">
                            <h5 className="workSanBold">AutoSave</h5>
                            <p className="workSan">You can turn ON or OFF your AutoSave to your wallet any time</p>

                            <div className="mt-4">
                                <Switch

                                    color={'primary'}
                                    // onChange={()=>alert('Hello')}
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    defaultValue={'hhjhjjj'}

                                />

                                <small>Turn on autoSave</small>

                            </div>

                            <div className="mt-24">
                                <button className="py-3 w-100 bg-blue-700 text-white text-center">Save Status</button>
                            </div>
                        </div>

                    </div>
                </Modal>
            )
        }
    }






    render() {

        const { savings, isLoading } = this.state
        const progress = this.calculateProgress()

        return (
            <Structure>

                {this.ModalContent()}

                <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
                    
                    {/* Header Section */}
                    <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 text-white py-12 px-4 md:px-8 rounded-b-3xl shadow-xl">
                        <div className="max-w-6xl mx-auto">
                            <div className="flex items-center gap-4 mb-4">
                                <div className="bg-white bg-opacity-20 p-3 rounded-full">
                                    <FeatherIcon icon="pocket" size="40" className="text-gray-600" />
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-2">
                                        <h1 className="text-4xl md:text-5xl font-bold workSanBold">
                                            {isLoading ? 'Loading...' : savings.title}
                                        </h1>
                                        {!isLoading && savings.is_locked && (
                                            <div className="w-8 h-8 bg-red-400 rounded flex items-center justify-center" title="Locked">
                                                <FeatherIcon icon="lock" size={18} className="text-white" />
                                            </div>
                                        )}
                                    </div>
                                    <p className="text-blue-100 text-lg mt-1">{savings.purpose}</p>
                                    {!isLoading && savings.end_date && (
                                        <p className="text-blue-100 text-sm workSanMedium mt-2 flex items-center gap-1">
                                            <FeatherIcon icon="clock" size={14} />
                                            Ends in: {this.getTimeRemaining(savings.end_date)}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="max-w-6xl mx-auto px- md:px-8 py-8">
                        
                        {/* Progress Section */}
                        <div className="mb-8 bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
                            <div className="mb-6">
                                <div className="flex justify-between items-center mb-3">
                                    <h3 className="text-lg font-bold workSanBold text-gray-800">Savings Progress</h3>
                                    <span className="text-sm font-semibold text-blue-600">{progress.toFixed(1)}%</span>
                                </div>
                                <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
                                    <div 
                                        className="bg-gradient-to-r from-blue-500 to-indigo-600 h-full rounded-full transition-all duration-500"
                                        style={{width: `${progress}%`}}
                                    ></div>
                                </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div className="flex justify-between items-center bg-blue-50 p-4 rounded-lg border border-blue-200">
                                    <div>
                                        <p className="text-gray-600 text-sm workSan">Saved</p>
                                        <h4 className="text-2xl font-bold text-blue-700 workSanBold">
                                            <NumberFormat value={savings.balance} displayType="text" thousandSeparator={true} prefix="₦" />
                                        </h4>
                                    </div>
                                    <FeatherIcon icon="arrow-up-right" size="32" className="text-green-500" />
                                </div>
                                <div className="flex justify-between items-center bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                                    <div>
                                        <p className="text-gray-600 text-sm workSan">Target</p>
                                        <h4 className="text-2xl font-bold text-indigo-700 workSanBold">
                                            <NumberFormat value={savings.target} displayType="text" thousandSeparator={true} prefix="₦" />
                                        </h4>
                                    </div>
                                    <FeatherIcon icon="target" size="32" className="text-indigo-500" />
                                </div>
                            </div>
                        </div>

                        {/* Key Metrics */}
                        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
                            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="bg-orange-100 p-2 rounded-lg">
                                        <FeatherIcon icon="zap" size="24" className="text-orange-600" />
                                    </div>
                                    <p className="text-gray-600 text-sm workSan">Period Target</p>
                                </div>
                                <h4 className="text-2xl font-bold text-gray-800 workSanBold">
                                    {savings.charge_period ? `₦${savings.charge_amount}/${savings.charge_period}` : 'N/A'}
                                </h4>
                            </div>

                            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="bg-purple-100 p-2 rounded-lg">
                                        <FeatherIcon icon="calendar" size="24" className="text-purple-600" />
                                    </div>
                                    <p className="text-gray-600 text-sm workSan">Timeline</p>
                                </div>
                                <h4 className="text-2xl font-bold text-gray-800 workSanBold">
                                    {savings.timeline_goal ? `${savings.timeline_goal} months` : 'Open'}
                                </h4>
                            </div>

                            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="bg-green-100 p-2 rounded-lg">
                                        <FeatherIcon icon="trending-up" size="24" className="text-green-600" />
                                    </div>
                                    <p className="text-gray-600 text-sm workSan">Transactions</p>
                                </div>
                                <h4 className="text-2xl font-bold text-gray-800 workSanBold">{this.state.history.length}</h4>
                            </div>

                            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="bg-blue-100 p-2 rounded-lg">
                                        <FeatherIcon icon="play-circle" size="24" className="text-blue-600" />
                                    </div>
                                    <p className="text-gray-600 text-sm workSan">Started</p>
                                </div>
                                <h4 className="text-lg font-bold text-gray-800 workSanBold">
                                    {savings.start_date ? new Date(savings.start_date).toLocaleDateString() : 'N/A'}
                                </h4>
                            </div>

                            <div className="bg-white rounded-xl shadow-md p-6 border border-gray-100 hover:shadow-lg transition-shadow">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="bg-red-100 p-2 rounded-lg">
                                        <FeatherIcon icon="activity" size="24" className="text-red-600" />
                                    </div>
                                    <p className="text-gray-600 text-sm workSan">Deadline</p>
                                </div>
                                <h4 className="text-lg font-bold text-gray-800 workSanBold">
                                    {savings.end_date ? new Date(savings.end_date).toLocaleDateString() : 'No limit'}
                                </h4>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                            <button 
                                onClick={this.modalAddMoney}
                                className="bg-gradient-to-r from-blue-600 to-blue-700 text-white py-4 px-6 rounded-xl font-bold flex items-center justify-center gap-3 hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                            >
                                <FeatherIcon icon="plus-circle" size="24" />
                                Save Money Now
                            </button>
                            <button 
                                onClick={this.modalAddSavings}
                                className="bg-gradient-to-r from-gray-700 to-gray-800 text-white py-4 px-6 rounded-xl font-bold flex items-center justify-center gap-3 hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                            >
                                <FeatherIcon icon="edit-3" size="24" />
                                Edit Purse
                            </button>
                        </div>

                        {/* Transaction & Withdrawal History Tabs */}
                        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">
                            {/* Tab Navigation */}
                            <div className="flex border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
                                <button
                                    onClick={() => this.setState({ activeHistoryTab: 'savings' })}
                                    className={`flex-1 py-4 px-6 font-bold workSanBold flex items-center justify-center gap-2 transition-all duration-300 border-b-4 ${
                                        this.state.activeHistoryTab === 'savings'
                                            ? 'border-blue-600 text-blue-600'
                                            : 'border-transparent text-gray-600 hover:text-gray-800'
                                    }`}
                                >
                                    <FeatherIcon icon="arrow-up-right" size="20" />
                                    Savings History
                                    <span className="ml-2 bg-blue-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                                        {this.state.history.length}
                                    </span>
                                </button>
                                <button
                                    onClick={() => this.setState({ activeHistoryTab: 'withdrawal' })}
                                    className={`flex-1 py-4 px-6 font-bold workSanBold flex items-center justify-center gap-2 transition-all duration-300 border-b-4 ${
                                        this.state.activeHistoryTab === 'withdrawal'
                                            ? 'border-red-600 text-red-600'
                                            : 'border-transparent text-gray-600 hover:text-gray-800'
                                    }`}
                                >
                                    <FeatherIcon icon="arrow-down-left" size="20" />
                                    Withdrawal History
                                    <span className="ml-2 bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                                        {this.state.withdrawalHistory.length}
                                    </span>
                                </button>
                            </div>

                            {/* Tab Content - Savings History */}
                            {this.state.activeHistoryTab === 'savings' && (
                                <div className="divide-y divide-gray-200">
                                    {this.state.history.length > 0 ? (
                                        this.state.history.map((history, index) => {
                                            const statusInfo = this.getStatusInfo(history.status)
                                            const paymentInfo = this.getPaymentMethodInfo(history)
                                            
                                            return (
                                                <div 
                                                    key={index}
                                                    onClick={() => this.openTransactionModal(history)}
                                                    className="p-6 hover:bg-blue-50 cursor-pointer transition-all duration-300 border-l-4 border-transparent hover:border-blue-600 group"
                                                >
                                                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                                                        {/* Left: Icon & Amount */}
                                                        <div className="flex items-center gap-4">
                                                            <div className={`p-3 rounded-full ${statusInfo.bgColor} group-hover:shadow-lg transition-all`}>
                                                                <FeatherIcon icon="arrow-up-right" size="24" className={statusInfo.textColor} />
                                                            </div>
                                                            <div>
                                                                <h4 className="font-bold text-gray-800 workSanBold">
                                                                    <NumberFormat value={history.amount} displayType='text' thousandSeparator={true} prefix="₦" />
                                                                </h4>
                                                                <p className="text-sm text-gray-500 workSan">{history.title}</p>
                                                            </div>
                                                        </div>

                                                        {/* Middle: Payment Method & Date */}
                                                        <div className="flex items-center gap-4">
                                                            <div className="hidden md:flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-lg">
                                                                <FeatherIcon icon={paymentInfo.icon} size="16" className={`text-${paymentInfo.color}-600`} />
                                                                <span className="text-xs font-semibold text-gray-700">{paymentInfo.label}</span>
                                                            </div>
                                                            <div className="text-right">
                                                                <p className="text-sm font-semibold text-gray-800">{history.date || history.payment_date}</p>
                                                            </div>
                                                        </div>

                                                        {/* Right: Status Badge */}
                                                        <div className="flex items-center gap-2">
                                                            <div className={`px-4 py-2 rounded-full flex items-center gap-2 ${statusInfo.badge}`}>
                                                                <FeatherIcon icon={statusInfo.icon} size="16" className={statusInfo.textColor} />
                                                                <span className={`text-sm font-semibold ${statusInfo.textColor}`}>{statusInfo.label}</span>
                                                            </div>
                                                            <FeatherIcon icon="chevron-right" size="20" className="text-gray-400 group-hover:text-blue-600 transition-colors" />
                                                        </div>
                                                    </div>

                                                    {/* Mobile Payment Method */}
                                                    <div className="mt-4 md:hidden flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-lg w-fit">
                                                        <FeatherIcon icon={paymentInfo.icon} size="16" className={`text-${paymentInfo.color}-600`} />
                                                        <span className="text-xs font-semibold text-gray-700">{paymentInfo.label}</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className="p-12 text-center">
                                            <FeatherIcon icon="inbox" size="48" className="text-gray-300 mx-auto mb-4" />
                                            <p className="text-gray-500 text-lg workSan">No savings yet</p>
                                            <p className="text-gray-400 text-sm mt-2">Start adding money to see your savings history here</p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Tab Content - Withdrawal History */}
                            {this.state.activeHistoryTab === 'withdrawal' && (
                                <div className="divide-y divide-gray-200">
                                    {this.state.withdrawalHistory && this.state.withdrawalHistory.length > 0 ? (
                                        this.state.withdrawalHistory.map((withdrawal, index) => {
                                            const statusInfo = this.getStatusInfo(withdrawal.status)
                                            
                                            return (
                                                <div 
                                                    key={index}
                                                    onClick={() => this.openWithdrawalModal(withdrawal)}
                                                    className="p-6 hover:bg-red-50 cursor-pointer transition-all duration-300 border-l-4 border-transparent hover:border-red-600 group"
                                                >
                                                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                                                        {/* Left: Icon & Amount */}
                                                        <div className="flex items-center gap-4">
                                                            <div className={`p-3 rounded-full ${statusInfo.bgColor} group-hover:shadow-lg transition-all`}>
                                                                <FeatherIcon icon="arrow-down-left" size="24" className={statusInfo.textColor} />
                                                            </div>
                                                            <div>
                                                                <h4 className="font-bold text-gray-800 workSanBold">
                                                                    <NumberFormat value={withdrawal.amount} displayType='text' thousandSeparator={true} prefix="₦" />
                                                                </h4>
                                                                <p className="text-sm text-gray-500 workSan">{withdrawal.purse_name}</p>
                                                            </div>
                                                        </div>

                                                        {/* Middle: Bank & Date */}
                                                        <div className="flex items-center gap-4">
                                                            <div className="hidden md:flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-lg">
                                                                <FeatherIcon icon="building" size="16" className="text-purple-600" />
                                                                <span className="text-xs font-semibold text-gray-700">{withdrawal.bank}</span>
                                                            </div>
                                                            <div className="text-right">
                                                                <p className="text-sm font-semibold text-gray-800">{withdrawal.date}</p>
                                                            </div>
                                                        </div>

                                                        {/* Right: Status Badge */}
                                                        <div className="flex items-center gap-2">
                                                            <div className={`px-4 py-2 rounded-full flex items-center gap-2 ${statusInfo.badge}`}>
                                                                <FeatherIcon icon={statusInfo.icon} size="16" className={statusInfo.textColor} />
                                                                <span className={`text-sm font-semibold ${statusInfo.textColor}`}>{statusInfo.label}</span>
                                                            </div>
                                                            <FeatherIcon icon="chevron-right" size="20" className="text-gray-400 group-hover:text-red-600 transition-colors" />
                                                        </div>
                                                    </div>

                                                    {/* Mobile Bank Info */}
                                                    <div className="mt-4 md:hidden flex items-center gap-2 bg-gray-100 px-3 py-2 rounded-lg w-fit">
                                                        <FeatherIcon icon="building" size="16" className="text-purple-600" />
                                                        <span className="text-xs font-semibold text-gray-700">{withdrawal.bank}</span>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className="p-12 text-center">
                                            <FeatherIcon icon="inbox" size="48" className="text-gray-300 mx-auto mb-4" />
                                            <p className="text-gray-500 text-lg workSan">No withdrawals yet</p>
                                            <p className="text-gray-400 text-sm mt-2">Your withdrawal history will appear here</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                    </div>

                </div>

            </Structure>
        );
    }
}

export default Purse;